import { render, staticRenderFns } from "./orthopedic-card-features.vue?vue&type=template&id=03f63345&scoped=true&"
import script from "./orthopedic-card-features.vue?vue&type=script&lang=js&"
export * from "./orthopedic-card-features.vue?vue&type=script&lang=js&"
import style0 from "./orthopedic-card-features.vue?vue&type=style&index=0&id=03f63345&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f63345",
  null
  
)

export default component.exports